import { UserNameInlineEditor } from 'components/inline_edit/UserNameInlineEditor';
import { UsersTableCellProps } from 'pages/Settings/Users/UsersTable';
import styled from 'styled-components';

const NameEditor = styled.div`
    display: grid;
    width: 50%;
    margin-right: 2rem;
    grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
`;

export function UserNameCell({ rowData, onChange }: UsersTableCellProps) {
    return (
        <>
            <NameEditor>
                <UserNameInlineEditor
                    rowData={rowData}
                    value={rowData.FirstName}
                    onChange={onChange}
                />
            </NameEditor>
            <NameEditor>
                <UserNameInlineEditor
                    rowData={rowData}
                    value={rowData.LastName}
                    onChange={onChange}
                />
            </NameEditor>
        </>
    );
}
